/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  num = (num / 100).toFixed(2)
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}



// WEBPACK FOOTER //
// ./src/filters/format.js